import { Component, OnInit } from '@angular/core';
import { GraphqlService } from '../../common/services/graphql.service';
import { LoginService } from '../../common/services/Login.service';
import { DomSanitizer } from '@angular/platform-browser';
import { CommonDataService } from '../../common/services/common-data.service';
import { Router } from '@angular/router';
import { UtilityService } from '../../common/services/utility-service';
import { constObj } from '../../common/Constants/constants';
import { ConfirmDialogComponent } from '../../common/shared-components/confirm-dialog/confirm-dialog.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-copyright',
  templateUrl: './copyright.component.html',
  styleUrls: ['./copyright.component.css']
})
export class CopyrightComponent implements OnInit {

  constructor(
    private commonDataService: CommonDataService,
    public loginService: LoginService,
    private graphQlService: GraphqlService,
    private sanitizer: DomSanitizer,
    private router: Router,
    public dialog: MatDialog,
    private utilityService: UtilityService) {
    this.isArchiveApplication();
  }
  copyrightHeader;
  copyrightBody;
  clickForInformation;
  copyrightlabels;
  archiveVersion: string = "";
  isArchive: boolean = false;

  ngOnInit(): void {
    this.getcopyrightlabels()
  }
  ngOnDestroy() {
    this.commonDataService.loadCurrentLeftNav.next(null);
  }
  getcopyrightlabels()
  {
    this.graphQlService.getCopyrightLabel().subscribe(data => {
      if (data != "") {
        var labels = data.content.data.labels;
        this.copyrightlabels = data.content.data.labels;
        labels = labels.filter(x => x.key.trim());
        this.copyrightHeader = labels.filter(x => x.key == "copyright_header").map(y => y.value);
        this.copyrightBody = labels.filter(x => x.key == "copyright_subtext").map(y => y.value?.replace("[YEAR_PLACEHOLDER]", new Date().getFullYear()));
        this.clickForInformation =this.sanitizer.bypassSecurityTrustHtml(labels.filter(x => x.key == "copyright_link").map(y => y.value));
      }
    });
   
  }
  OpenLink(event) {
    let id = event.currentTarget.id;
    if (id != null) {
      window.open(this.copyrightlabels.filter(x => x.key == id).map(y => y.value));

    }

  }
  isArchiveApplication() {
    this.archiveVersion = localStorage.getItem("ArchiveVersion");
    if (localStorage.getItem("publicationId") != undefined && localStorage.getItem("currentVersionPublicationId") != localStorage.getItem("publicationId")) {
      this.archiveVersion = this.utilityService.convertMonthYear(localStorage.getItem("ArchiveVersion"));
      this.isArchive = Boolean(this.archiveVersion);
    }
    else if (this.router.url.split("/")[1] != localStorage.getItem("currentVersionPublicationId") && (this.archiveVersion != null && this.archiveVersion != undefined)) {
      this.archiveVersion = localStorage.getItem("ArchiveVersion");
      this.isArchive = Boolean(this.archiveVersion);
    }
    else { this.isArchive = false; }
  }
  BackToCurrentContent() {
    const PrintQueueSession = localStorage.getItem("SetPrintQueueSession");
    var printQueueCount: any = PrintQueueSession == "{}" ? 0 : PrintQueueSession == null ? 0 : PrintQueueSession == "" ? 0 : JSON.parse(localStorage.getItem("SetPrintQueueSession")).ParagraphIdsList.length;
    let popUpMessage = constObj.currentVersionNavigationAlert;
    if (printQueueCount > 0) {
      popUpMessage += "<br/>" + constObj.annotationAlertPrintQueue;
    }
    else { popUpMessage += "<br/>" + constObj.continueMessage; }
    localStorage.setItem("isConfirmPopup", "true");
    this.commonDataService.isConfirmationPopUpOpen.next(true);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      disableClose: true,
      width: '600px',
      data: popUpMessage
    });
    dialogRef.afterClosed().subscribe((result: boolean) => {
      localStorage.removeItem("isConfirmPopup");
      if (result == true) {
        this.commonDataService.resetPrintQueue.next(true);
        this.commonDataService.printCount.next("toggleOff");
        this.commonDataService.printToggleOff.next("printToggleOff");
        localStorage.removeItem("ArchiveVersion");
        this.commonDataService.loadCurrentLeftNav.next(localStorage.getItem("currentVersionPublicationId"));
        this.router.navigateByUrl("/Home")
      }
    });
  }

}
